import Vue from 'vue'
// 使用插件
import VueI18n from 'vue-i18n'
Vue.use(VueI18n)

const i18n = {
  locale: localStorage.getItem('lang') || 'en', // 语言标识,第一次登录默认是英语
  messages: {
    zh: require('./language/local_zh'), // 中文
    en: require('./language/local_en'), // 英语
    kr: require('./language/local_kr'), // 韩语
    jp: require('./language/local_jp'), // 日语
    my: require('./language/local_my'), // 马来语
  },
}

export default i18n
